import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useToleranceById, useSaveTolerances } from "./useTolerances";

const BASE_FORM = {
	is_active: false,
	lower_margin: 10,
	upper_margin: 10,
};

export function useToleranceForm({ option, filters, elementId, onClose }) {
	const isOpen = option === "editar" || option === "crear";
	const isEditMode = option === "editar";
	const modalTitle = isEditMode ? "Editar Tolerancia" : "Crear Tolerancia";

	const { mutate: save, isLoading: isLoadingSave } = useSaveTolerances();

	const { data: element, isLoading: isLoadingElement, isFetching: isFetchingElement } = useToleranceById(elementId, isEditMode);

	const [formState, setFormState] = useState({ ...BASE_FORM });
	const [formErrors, setFormErrors] = useState({});

	useEffect(() => {
		if (isEditMode && element?.detail) {
			setFormState({
				is_active: element.detail.is_active ?? false,
				lower_margin: element.detail.lower_margin ?? 10,
				upper_margin: element.detail.upper_margin ?? 10,
			});
		}
	}, [isEditMode, element]);

	useEffect(() => {
		if (!isOpen) {
			setFormState({ ...BASE_FORM });
			setFormErrors({});
		}
	}, [isOpen]);

	const validateForm = (state) => {
		const errors = {};
		if (state.is_active) {
			if (state.lower_margin === "" || state.lower_margin === null || state.lower_margin === undefined) {
				errors.lower_margin = "Requerido";
			} else if (Number(state.lower_margin) < 0 || Number(state.lower_margin) > 100) {
				errors.lower_margin = "Debe estar entre 0 y 100";
			}
			if (state.upper_margin === "" || state.upper_margin === null || state.upper_margin === undefined) {
				errors.upper_margin = "Requerido";
			} else if (Number(state.upper_margin) < 0 || Number(state.upper_margin) > 100) {
				errors.upper_margin = "Debe estar entre 0 y 100";
			}
		}
		return errors;
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const errors = validateForm(formState);
		setFormErrors(errors);
		if (Object.keys(errors).length) return;

		const form = {
			is_active: formState.is_active,
			lower_margin: Number(formState.lower_margin),
			upper_margin: Number(formState.upper_margin),
		};

		if (!isEditMode) {
			form.estate_id = Number(elementId);
		}
		if (isEditMode) {
			form.id = Number(elementId);
		}

		save(
			{ form, ...filters },
			{
				onSuccess: () => {
					toast.success(isEditMode ? "Tolerancia actualizada correctamente" : "Tolerancia creada correctamente");
					onClose();
				},
				onError: (error) => {
					toast.error(error?.response?.data?.message || "Error al guardar la tolerancia");
				},
			},
		);
	};

	const isLoading = isLoadingSave || isLoadingElement || isFetchingElement;

	return {
		isOpen,
		modalTitle,
		isLoading,
		formState,
		setFormState,
		formErrors,
		handleSubmit,
	};
}
